// src/utils/marketplaceConfig.ts
// 0 = All
export const MARKETPLACE_IDS_FOR_MEMBERSHIP: Record<string, number[]> = {
    Staging: [3395, 245, 3472, 3342, 3454, 3481, 1, 4, 82, 99, 79, 53, 33],
    Development: [0],
    Production: [1, 4, 5284, 82, 99, 79, 53, 33]
};

export const membershipMarketplaceIds = () => {
    const environment = process.env.REACT_APP_ENVIRONMENT ?? 'Production';
    return MARKETPLACE_IDS_FOR_MEMBERSHIP[environment] || [];
};

/*
Production:
[33, "BluesClues"]
[4, "HealthySmiles | House Calls"],
[1, "HealthySmiles Pet Dental | Plantation"],
[5284, "HealthySmiles | Boca"],
[82, "HealthySmiles | Cypress TX"],
[99, "HealthySmiles | Miami"],
[79, "HealthySmiles Pet Dental (Field)"],
[53, "HealthySmiles | Fort Lauderdale "]
*/
